<template>
  <div v-if="content.length && JSON.stringify(content[0]) !== '{}' && content[0].date && content[0].date.length" class="jin-m-curr">
    <ul class="jin-m-curr-con">
      <li
        v-for="(item, i) in content"
        :key="i"
        class="jin-m-curr-con-item"
        @click="$router.push({
          path: `/list/resume/${template}?idx=${i}`,
          query: $route.query
        })"
      >
        <p class="name">
          <span>{{ item.name }}</span>
          <Icon name="arrow-right" />
        </p>
        <span v-if="item.url" class="url" @click="handleLink(item.url)">{{ item.url }}</span>
        <p v-if="item.item1" class="info">{{ item.item1 }}{{ item.item2 ? ' / ' + item.item2 : '' }}{{ item.item3 ? ' / ' + item.item3 : '' }}</p>
        <p v-if="item.date" class="time">{{ item.date[0] }}-{{ item.date[1] }}</p>
        <p v-if="item.desc" class="desc">{{ item.desc }}</p>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  props: {
    info: {
      type: Array,
      default: () => []
    },
    template: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      content: []
    }
  },
  watch: {
    info: {
      handler(n) {
        if (n) {
          this.handleForm()
        }
      }
    }
  },
  created() {
    this.handleForm()
  },
  methods: {
    handleLink(url) {
      window.location.href = url
    },
    handleForm() {
      if (!(this.info && this.info.length)) {
        this.content = []
      } else {
        this.content = this.info.map(item => {
          return {
            name: item.education || item.company_name || item.project_name,
            date: item.date,
            item1: item.education || item.job,
            item2: item.education_type || item.job_type,
            item3: item.major,
            desc: item.description,
            url: item.url
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.jin-m {
  &-curr {
    /deep/ .van-swipe-cell {
      // display: flex;
      // align-items: center;
      margin-bottom: 5px;

      .curr-delete {
        padding: 3px 5px;
        background: #ff5265;
        color: #fff;
        font-size: 10px;
      }
    }

    margin-top: 20px;

    &-con-item {
      margin-bottom: 20px;

      &:nth-last-child(1) {
        margin-bottom: 0;
      }
    }

    .name {
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        font-size: 15px;
        color: #3d4351;
        line-height: 18px;
      }

      i {
        font-size: 14px;
        color: #787b8a;
      }
    }

    .url {
      cursor: pointer;
      font-size: 13px;
      font-weight: 400;
      color: #4777f4;
      margin-bottom: 7px;
    }

    .info {
      font-size: 13px;
      color: #3d4351;
      line-height: 18px;
      margin-bottom: 7px;
    }

    .time {
      font-size: 12px;
      color: #a0a4b7;
      line-height: 18px;
      margin-bottom: 5px;
    }

    .desc {
      font-size: 12px;
      color: #787b8a;
      line-height: 20px;
    }
  }
}
</style>
